export default __webpack_public_path__ + "static/media/800-900.3e24f837.jpg";